import React from 'react';
import styled from 'styled-components';

const StyledContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: ${({ theme }) => theme?.spacing?.small};

  text-align: center;
  font-size: ${({ theme }) => theme.fontSize.default};

  padding: ${({ theme }) => theme?.spacing?.large};
  background: ${({ theme }) => theme.palette.white};
  border-radius: ${({ theme }) => theme.radius.small};

  .title {
    font-weight: bold;
  }

`;

export const NotAuthorized = () => {
  return (
    <StyledContainer>
      <h2 className="title">Not Authorized.</h2>
      <p>
        You don't have the required permissions to view this content. <br /> Please contact your administrator if you believe
        this is a mistake.
      </p>
    </StyledContainer>
  );
};
